module.exports = __webpack_public_path__ + "img/零食标题.d2760215.png";